module.exports = __webpack_public_path__ + "static/media/microphone-slash.3dc0ab95.svg";